
























import { Vue, Component, Prop } from 'vue-property-decorator'
import VueI18n from 'vue-i18n'
import { App } from '@/models'

@Component({})
export default class AppAppContextualMenu extends Vue {
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly icon!: string
  @Prop() readonly title!: string
  @Prop({ default: 0 }) readonly position!: string
  @Prop() readonly appMenuStyle!: boolean
  @Prop() readonly app!: App
  @Prop() readonly isAppOnDesktop!: boolean
  @Prop() readonly hasSlot!: boolean

  onRemoveClick () {
    this.$emit('remove')
  }

  onOutsideClick () {
    this.$emit('outside')
  }

  onNewTabClick () {
    this.$emit('opentab')
  }

  onUninstallClick () {
    this.$emit('uninstall')
  }
}
